module.exports = __webpack_public_path__ + "static/media/moilogo.6d10bcdf.png";